export default function isNot(value, comparator) {
  return value != comparator;
}
